import type { IconData } from '@stacksjs/iconify-core'

export const basicUiCheck2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4.5-9.5l-2-2L7 8L5.5 6.5l-2 2L7 12z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiCheck2
